import React from "react";
import styled from "styled-components";
import { OverlayTrigger } from "components/common";
import { Label } from "components/bootstrap";
const OverlayContent = styled.span`
  word-break: break-word;
`;
export const stateToStyle = (state) => {
  switch (state) {
    case "RUNNING":
      return "success";
    case "FAILED":
    case "FAILING":
    case "INVALID_CONFIGURATION":
      return "danger";
    case "STARTING":
    case "CREATED":
    case "INITIALIZED":
    case "STOPPED":
    case "TERMINATED":
    case "STOPPING":
      return "info";
    default:
      return "warning";
  }
};
export const stateToText = (state) => {
  switch (state) {
    case "RUNNING":
      return "Running";
    case "FAILED":
    case "INVALID_CONFIGURATION":
      return "Failed";
    case "FAILING":
      return "Failing";
    case "STARTING":
    case "CREATED":
    case "INITIALIZED":
      return "Starting";
    case "STOPPED":
    case "TERMINATED":
      return "Not running";
    case "STOPPING":
      return "Stopping";
    default:
      return "Unknown";
  }
};
export const isFailureState = (state) => state === "FAILED" || state === "FAILING" || state === "INVALID_CONFIGURATION";
const ForwarderInputStateLabel = ({ state = void 0, stateMessage = void 0 }) => {
  const label = /* @__PURE__ */ React.createElement(Label, { bsStyle: stateToStyle(state) }, stateToText(state));
  if (isFailureState(state) && stateMessage) {
    return /* @__PURE__ */ React.createElement(OverlayTrigger, { trigger: "hover", placement: "top", overlay: /* @__PURE__ */ React.createElement(OverlayContent, null, stateMessage) }, label);
  }
  return label;
};
export default ForwarderInputStateLabel;
